import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Vi kaj mi kaj kune ni (2 foje), <br/>
        Kiel bone, ke ekzistas amikar’! <br/>
        Se ni ĉiuj vivus ne kune, <br/>
        Se ni ĉiuj vivus po unu – <br/>
        Tiam sun’ nigriĝus kaj sekiĝus mar’.
      </p>

      <p class="poem-block mb-3">
        Vi kaj mi kaj kune ni (2 foje), <br/>
        Por la amikeco ne ekzistas lim’: <br/>
        Ie malproksime de l’ Tero <br/>
        Apud la oranĝa rivero <br/>
        Fratoj el alia mond’ atendas nin.
      </p>

      <p class="poem-block mb-3">
        Vi kaj mi kaj kune ni (2 foje), <br/>
        Ne disigos nin eĉ aroganta fort’: <br/>
        Estu inter ni oceanoj, <br/>
        Fulmotondroj kaj uraganoj – <br/>
        Amikeco restos por ĉiam sen mort’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Vi kaj mi kaj kune ni'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['XtHoEooBvZM'],
    itemTranslator: `
      Teksto: V. Potockij, <br/>
      Muziko: V. Zvanov, <br/>
      ${translator.esp}
    `
  }
}

export default item;